import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import { appContext } from '../../util/decorators';
import PageHeading from '../PageHeading.jsx';
import Loader from '../Loader.jsx';
import { formatHeadingText } from '../../util/formatSportHeadingText';
import FeedContainerSmall from '../NewsFeed/FeedContainerSmall.jsx';
import InfiniteScrollLoader from '../InfiniteScrollLoader';
import VideoMeta from './VideoMeta';
import TranslatedLink from '../TranslatedLink.jsx';
import SideScrollableContainer from './SideScrollableContainer.jsx';

const isRenderableVideo = (contentContainer, serverTime) => {
  const sixAmNextDay = serverTime.clone().hour(6).minute(0).add(1, 'days');
  return _.get(contentContainer, 'tags.events[0]')
    && _.get(contentContainer, 'tags.competitions[0].en.name')
    && contentContainer.extendedEvent
    && moment(contentContainer.extendedEvent.startdate).isBefore(sixAmNextDay);
};

@appContext
export default class VideoList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.dataOffset = _.size(props.videos) || 0;
  }

  componentDidUpdate(previousProps) {
    if (previousProps.routeParams !== this.props.routeParams) {
      this.dataOffset = 0;
    }
  }

  getDateString(dateYMD, dateFormat) {
    const t = this.context.app.t;
    return moment(dateYMD).calendar(null, {
      sameDay: `[${t('VideoIndex.today')}]`,
      lastDay: `[${t('VideoIndex.yesterday')}]`,
      nextDay: dateFormat,
      nextWeek: dateFormat,
      lastWeek: dateFormat,
      sameElse: dateFormat,
    });
  }

  getEventDisplayName({extendedEvent}) {
    if (extendedEvent.home_name) {
      return `${extendedEvent.home_name} - ${extendedEvent.away_name}`;
    }

    return extendedEvent.tournament_stage_name;
  }

  loadMoreData() {
    const { routeParams, country, loadMoreData, language, videosPerRequest } = this.props;
    this.dataOffset = this.dataOffset + videosPerRequest;
    return loadMoreData(routeParams, country, this.dataOffset, language);
  }

  render() {
    const t = this.context.app.t;
    const { videos, routeParams: { sports }, country, className } = this.props;

    const pageData = _.chain(videos)
      .filter(video => isRenderableVideo(video, this.context.app.serverTime()))
      .sortBy(video => _.first(video.tags.videoTypes) !== 'summary')
      .groupBy('tags.events[0]')
      .groupBy(containersGroupedByEvents =>
        moment(containersGroupedByEvents[0].extendedEvent.startdate).format('YYYY-MM-DD')
      )
      .map((groupedByStartDate, key) =>({
        date: key,
        groups: _.groupBy(groupedByStartDate, `[0].tags.competitions[0].${country}.name`),
      }))
      .uniqBy('date')
      .orderBy('date', 'desc')
      .value();
    return (
      <section className={`video-index ${className}`}>
        { !sports && <VideoMeta /> }

        <PageHeading firstPart={formatHeadingText(country, sports)} secondPart={t('VideoIndex.heading')} />

        { _.isArray(videos) && _.isEmpty(pageData) && <div className="empty-page">{t('VideoIndex.no_events')}</div> }

        { !_.isArray(videos) && <Loader/> }

        <section>
          {
            pageData.map(date => {
              const dateLabel = this.getDateString(date.date, 'DD/MM');
              return (
                <section key={date.date} className="date-section">
                  <div className="date-separator" id={date.date}>{dateLabel}</div>
                  {
                    date.groups === null ?
                      <span className="empty-message">{t('VideoIndex.no_events_for_date')}</span>
                    :
                      Object.keys(date.groups).map(groupName => {
                        const group = date.groups[groupName];

                        return (
                          <div key={date.date + groupName}>
                            <div className="highlight-box group-heading">
                              <h2 className="section">{groupName}</h2>
                            </div>

                            {
                              group.map(videoPosts => {
                                const event = videoPosts[0].extendedEvent;
                                const displayName = this.getEventDisplayName(videoPosts[0]);
                                const eventsPage = sports ? 'EventsPage' : 'EventsPageAllSports';
                                const eventsParams = sports ? [sports, event.id] : [event.id];

                                return (
                                  <div key={event.id} className="highlight-box no-margin">
                                    <div className="section horizontal-center dark">
                                      { event.homefk !== '0' && <img className="team-logo" src={'//ximg.enetscores.com/cdnimg/amalthea/logo/teamlogo/' + event.homefk}/> }
                                      <div className="event-heading">{displayName}</div>
                                      { event.awayfk !== '0' && <img className="team-logo" src={'//ximg.enetscores.com/cdnimg/amalthea/logo/teamlogo/' + event.awayfk}/> }
                                      <TranslatedLink name={eventsPage} routeParams={eventsParams} className="all-clips-link">
                                        { videoPosts.length === 1 ? t('VideoIndex.show_clip') : `${t('VideoIndex.show_clips')} ${videoPosts.length} ${t('VideoIndex.show_clips_2')}` }
                                      </TranslatedLink>
                                    </div>
                                    <SideScrollableContainer className="section">
                                      { videoPosts.map(videoPost => <FeedContainerSmall key={videoPost.id} useVideoTypeTags contentContainer={videoPost} />) }
                                    </SideScrollableContainer>
                                  </div>
                                );
                              })
                            }
                          </div>
                        );
                      })
                  }
                </section>
              );
            })
          }

          <InfiniteScrollLoader loadMore={() => this.loadMoreData()}
                                lastRequestedOffset={this.dataOffset}
                                loadedOffset={_.size(videos)} />
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Video/VideoList.jsx